import { render, staticRenderFns } from "./editPass.vue?vue&type=template&id=7dc8cbf4&scoped=true&"
import script from "./editPass.vue?vue&type=script&lang=js&"
export * from "./editPass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc8cbf4",
  null
  
)

export default component.exports